import React from 'react';

import { COUNT_KEYS, OUTCOME_LABEL, STATUS_LABEL, formatNumber } from './format';

// The small pieces every screen here repeats: a run's status, whether it wrote
// anything, and the five counts. Defined once so the overview, the history row
// and the run detail cannot drift into describing the same run differently.
//
// The design uses two pill sizes: the 24px uppercase pill on the hero and the
// detail head, and the quieter 22px cell pill inside table rows and search
// hits. `cell` picks the second.

export function StatusPill({ status, cell }) {
    const base = cell ? 'ls-cellpill' : 'ls-pill';
    return (
        <span className={base + ' ' + base + '--' + status}>
            <span className={base + '__dot'} />
            {STATUS_LABEL[status] || status}
        </span>
    );
}

/**
 * A dry run decides everything and writes nothing, and its counts look exactly
 * like a real run's. The hatched treatment is the only thing standing between
 * "43 created" and someone believing 43 properties exist.
 */
export function ModePill({ mode, cell }) {
    const base = cell ? 'ls-cellpill' : 'ls-pill';
    const dry = mode === 'dry_run';
    return <span className={base + ' ' + base + '--mode' + (dry ? ' is-dry' : '')}>{dry ? 'Dry run' : 'Write'}</span>;
}

export function OutcomePill({ outcome }) {
    const variant = outcome === 'failed' ? 'failed-outcome' : outcome;
    return <span className={'ls-cellpill ls-cellpill--' + variant}>{OUTCOME_LABEL[outcome] || outcome}</span>;
}

export function CountChips({ run, large }) {
    const dry = run.mode === 'dry_run';

    return (
        <div className={'ls-counts' + (large ? ' ls-counts--large' : '')}>
            {COUNT_KEYS.map((key) => {
                const value = run[key] || 0;
                const className = [
                    'ls-count',
                    'ls-count--' + key,
                    value ? '' : 'is-zero',
                    dry ? 'is-dry' : '',
                ].filter(Boolean).join(' ');

                return (
                    <div key={key} className={className}>
                        <div className="ls-count__value">{formatNumber(value)}</div>
                        <div className="ls-count__label">{OUTCOME_LABEL[key]}</div>
                    </div>
                );
            })}
        </div>
    );
}

export function Chevron({ className }) {
    return (
        <svg className={className} width="13" height="13" viewBox="0 0 13 13" fill="none"
            stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <path d="M4.6 2.8 L8.6 6.5 L4.6 10.2" />
        </svg>
    );
}
